import * as $runtime from "../runtime.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import {_getGlobalDefaultLocale, _getGlobalLocale, _interpolate, _setGlobalLocale, _translate, _translateIn} from "./foreign.js";
const translationPending_ = defaultTranslation => defaultTranslation;
const translationPending = () => () => $0 => $1 => _interpolate($0, $1);
const translateIn = locale => key => values => _translateIn(
  (() => {
    if (locale.tag === "PL") { return "pl"; }
    if (locale.tag === "EN") { return "en"; }
    if (locale.tag === "EN_GB") { return "en-GB"; }
    if (locale.tag === "RO") { return "ro"; }
    if (locale.tag === "RU") { return "ru"; }
    if (locale.tag === "CS") { return "cs"; }
    if (locale.tag === "SK") { return "sk"; }
    if (locale.tag === "HR") { return "hr"; }
    if (locale.tag === "DE") { return "de"; }
    if (locale.tag === "NL") { return "nl"; }
    if (locale.tag === "ES") { return "es"; }
    if (locale.tag === "IT") { return "it"; }
    if (locale.tag === "UK") { return "uk"; }
    if (locale.tag === "SL") { return "sl"; }
    if (locale.tag === "SR") { return "sr"; }
    if (locale.tag === "PT_BR") { return "pt-BR"; }
    $runtime.fail();
  })(),
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(key),
  values
);
const translateIn_ = locale => key => translateIn(locale)(key)({});
const translate = key => values => _translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(key), values);
const translate_ = key => _translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(key), {});
const setGlobalLocale = locale => {
  const $0 = (() => {
    if (locale.tag === "PL") { return "pl"; }
    if (locale.tag === "EN") { return "en"; }
    if (locale.tag === "EN_GB") { return "en-GB"; }
    if (locale.tag === "RO") { return "ro"; }
    if (locale.tag === "RU") { return "ru"; }
    if (locale.tag === "CS") { return "cs"; }
    if (locale.tag === "SK") { return "sk"; }
    if (locale.tag === "HR") { return "hr"; }
    if (locale.tag === "DE") { return "de"; }
    if (locale.tag === "NL") { return "nl"; }
    if (locale.tag === "ES") { return "es"; }
    if (locale.tag === "IT") { return "it"; }
    if (locale.tag === "UK") { return "uk"; }
    if (locale.tag === "SL") { return "sl"; }
    if (locale.tag === "SR") { return "sr"; }
    if (locale.tag === "PT_BR") { return "pt-BR"; }
    $runtime.fail();
  })();
  return () => _setGlobalLocale($0);
};
const isStringRecordNil = {};
const isStringRecordCons = () => ({});
const getTranslation = dict => dict.getTranslation;
const getGlobalDefaultLocale = () => {
  const str = _getGlobalDefaultLocale();
  const v = Restaumatic$dLocales.fromText(str);
  if (v.tag === "Nothing") {
    Effect$dConsole.log("WARNING: Invalid global default locale: " + Data$dShow.showStringImpl(str) + ". Defaulting to " + Restaumatic$dLocales.showLocale.show(Restaumatic$dLocales.EN))();
    return Restaumatic$dLocales.EN;
  }
  if (v.tag === "Just") { return v._1; }
  $runtime.fail();
};
const getGlobalLocale = dictMonadEffect => dictMonadEffect.liftEffect(() => {
  const str = _getGlobalLocale();
  const v = Restaumatic$dLocales.fromText(str);
  if (v.tag === "Nothing") {
    Effect$dConsole.log("WARNING: Invalid global locale: " + Data$dShow.showStringImpl(str) + ". Defaulting to " + Restaumatic$dLocales.showLocale.show(Restaumatic$dLocales.EN))();
    return Restaumatic$dLocales.EN;
  }
  if (v.tag === "Just") { return v._1; }
  $runtime.fail();
});
export {
  getGlobalDefaultLocale,
  getGlobalLocale,
  getTranslation,
  isStringRecordCons,
  isStringRecordNil,
  setGlobalLocale,
  translate,
  translateIn,
  translateIn_,
  translate_,
  translationPending,
  translationPending_
};
export * from "./foreign.js";
